import { PostApiWithAuthorizationAction } from "constantFunctions/apiActions";
import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
  CustomInput,
} from "reactstrap";

function AddNewFromOptionModal(props) {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const addOptionHandler = (e) => {
    let body = {
      name: name,
    };
    setLoading(true);
    PostApiWithAuthorizationAction("common/add-new-from-option", body)
      .then((res) => {
        setLoading(false);
        //toast.success(res.message);
        props.fetchFromOptionsListing();
        props.toggle();
      })
      .catch((err) => {
        setLoading(false);
        if (err.status === 440) {
          toast.error(err.message, { position: toast.POSITION.TOP_CENTER });
          props.history.push("/auth/login");
        }
      });
  };
  return (
    <Modal isOpen={props.show} toggle={props.toggle}>
      <ModalHeader toggle={props.toggle}>Add new From Option</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label className="form-control-label" for="name">
            Name
          </Label>
          <Input
            id={"option_name"}
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <span className="text-danger">
            <small>*required</small>
          </span>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        {loading ? (
          <Button color="primary" disabled>
            Adding <i className="fas fa-spinner fa-spin"></i>
          </Button>
        ) : (
          <>
            <Button
            id="add-btn"
              color="primary"
              onClick={addOptionHandler}
              disabled={name.length === 0}
            >
              Add
            </Button>{" "}
            <Button color="secondary" onClick={props.toggle}>
              Cancel
            </Button>
          </>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default AddNewFromOptionModal;
